import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL } from "../helpers/constants";
import { partyTheme } from "./accountDetail/accountDetailTheme";
import AppPageHeader from "../components/AppPageHeader";

function AccountManagement() {
  const navigate = useNavigate();
  const { token, user, logout } = useAuth();

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user?.user_id) {
      fetchAccounts();
    }
  }, [user]);

  const fetchAccounts = async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${API_BASE_URL}/v1/account`, {
        headers: {
          "Content-Type": "application/json",
          "X-User-Id": user.user_id,
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Failed to fetch accounts");
      }

      setAccounts(data.accounts || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAccountClick = (accountId) => {
    navigate(`/account/${accountId}`);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        color: "#2f2f2d",
      }}
    >
      <AppPageHeader
        title="Accounts"
        user={user}
        onLogout={handleLogout}
      />

      <div
        style={{
          padding: "14px 16px",
          background: partyTheme.theirs.bg,
          borderBottom: `1px solid ${partyTheme.chrome.neutralRule}`,
          fontSize: "11px",
          color: "#6a6255",
          lineHeight: 1.35,
        }}
      >
        Select an account to open portfolio setup and claim analysis.
      </div>

      <main style={{ padding: "16px" }}>
        {loading && (
          <p style={{ fontSize: "12px", lineHeight: 1.3, color: "#666" }}>
            Loading accounts...
          </p>
        )}

        {error && (
          <div
            style={{
              padding: "10px 12px",
              background: "#fdecec",
              border: "1px solid #e9bcbc",
              color: "#8f1e1e",
              maxWidth: "620px",
              fontSize: "12px",
              lineHeight: 1.35,
            }}
          >
            <strong>Error:</strong> {error}
          </div>
        )}

        {!loading && !error && accounts.length === 0 && (
          <div
            style={{
              padding: "14px",
              border: `1px solid ${partyTheme.chrome.panelBorder}`,
              background: "#faf9f7",
              maxWidth: "620px",
              fontSize: "12px",
              lineHeight: 1.35,
              color: "#6a6255",
            }}
          >
            No accounts found. Please create an account to get started.
          </div>
        )}

        {!loading && !error && accounts.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              maxWidth: "700px",
            }}
          >
            {accounts.map((account) => (
              <button
                key={account.account_id}
                type="button"
                className="account-list-item"
                onClick={() => handleAccountClick(account.account_id)}
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  padding: "10px 12px",
                  cursor: "pointer",
                  border: `1px solid ${partyTheme.chrome.cardBorder}`,
                  borderRadius: 0,
                  textAlign: "left",
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    lineHeight: 1.25,
                    fontWeight: 600,
                    color: partyTheme.chrome.heading,
                    marginBottom: "3px",
                  }}
                >
                  {account.account_name}
                </div>
                <div style={{ fontSize: "11px", lineHeight: 1.3, color: "#666" }}>
                  Customer ID: {account.customer_id}
                </div>
                <div style={{ fontSize: "11px", lineHeight: 1.3, color: "#666" }}>
                  Account ID: {account.account_id}
                </div>
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default AccountManagement;
